<div class="row">
    <div class="col-12">
        <!-- Tabs de navegación -->
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a [href]="'#general'" data-bs-toggle="tab" (click)="tabSelected = 1" class="nav-link"
                    [class.active]="tabSelected ==1">Datos Generales</a>
            </li>
        </ul>
    </div>
</div>

@if(tabSelected==1){
<div class="tab-content panel p-4" [ngClass]="{ 'show active rounded-0 rounded-bottom': tabSelected>0 }">
    <div class="tab-pane fade" [ngClass]="{ 'show active ': tabSelected==1 }" id="general">
        <div class="panel-body">

            <!-- Formulario de Siniestro -->
            <form [formGroup]="claimForm">
                <div class="row mb-3">

                    <!-- Tipo de Siniestro -->
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Tipo de Siniestro</label>
                            @if(mode == formMode.EDIT){
                            <select class="form-select" formControlName="type">
                                @for(type of claimTypes; track type.code){
                                <option [value]="type.code">{{type.name}}</option>
                                }
                            </select>
                            }@else{
                            <div class="form-group">
                                <strong>{{getTypeName(claimForm.get('type')?.value)}}</strong>
                            </div>
                            }
                        </div>
                    </div>

                    <!-- Fecha -->
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Fecha del Siniestro</label>
                            @if(mode == formMode.EDIT){
                            <input type="date" class="form-control" formControlName="date">
                            }@else{
                            <div class="form-group">
                                <strong>{{claimForm.get('date')?.value | date: 'dd/MM/yyyy'}}</strong>
                            </div>
                            }
                        </div>
                    </div>

                    <!-- Estado -->
                    <div class="col-md-5">
                        <div class="form-group">
                            <label>Estado</label>
                            @if(mode == formMode.VIEW){
                            <div class="d-flex align-items-center">
                                <span class="badge {{getStatusClass(data().status)}} me-2">
                                    {{getStatusName(data().status)}}
                                </span>
                                <div ngbDropdown container="body">
                                    <button ngbDropdownToggle type="button" class="btn btn-outline-secondary btn-xs">
                                        <i class="fas fa-exchange-alt"></i> Cambiar Estado
                                    </button>
                                    <div ngbDropdownMenu>
                                        @for(status of claimStatuses; track status.code){
                                        @if(status.code !== data().status){
                                        <button ngbDropdownItem (click)="updateStatus(status.code)">
                                            <span class="badge {{status.class}}">{{status.name}}</span>
                                        </button>
                                        }
                                        }
                                    </div>
                                </div>
                            </div>
                            }@else{
                            <select class="form-select" formControlName="status">
                                @for(status of claimStatuses; track status.code){
                                <option [value]="status.code">{{status.name}}</option>
                                }
                            </select>
                            }
                        </div>
                    </div>
                </div>

                <!-- Descripción -->
                <div class="row mb-3">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Descripción</label>
                            @if(mode == formMode.EDIT){
                            <textarea class="form-control" formControlName="description" rows="3"></textarea>
                            }@else{
                            <div class="form-group">
                                <strong>{{claimForm.get('description')?.value || 'Sin descripción'}}</strong>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- Montos -->
                <div class="row mb-3">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Presupuesto</label>
                            @if(mode == formMode.EDIT){
                            <input type="number" class="form-control" formControlName="budgetAmount">
                            }@else{
                            <div class="form-group">
                                <strong>${{claimForm.get('budgetAmount')?.value || 0 | number:'1.0-0'}}</strong>
                            </div>
                            }
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Deducible</label>
                            @if(mode == formMode.EDIT){
                            <input type="number" class="form-control" formControlName="deductibleAmount">
                            }@else{
                            <div class="form-group">
                                <strong>${{claimForm.get('deductibleAmount')?.value || 0 | number:'1.0-0'}}</strong>
                            </div>
                            }
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Monto Aprobado</label>
                            @if(mode == formMode.EDIT){
                            <input type="number" class="form-control" formControlName="approvedAmount">
                            }@else{
                            <div class="form-group">
                                <strong>${{claimForm.get('approvedAmount')?.value || 0 | number:'1.0-0'}}</strong>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- Botones de Acción -->
                <div class="d-flex justify-content-end">
                    @if(mode == formMode.EDIT){
                    <button class="btn btn-primary btn-sm" (click)="submitClaim()">
                        <i class="fa fa-save"></i> Actualizar
                    </button>
                    <button class="btn btn-outline-secondary btn-sm ms-2" (click)="onModeChange(formMode.VIEW)">
                        <i class="fa fa-times"></i> Cancelar
                    </button>
                    }
                    @if(mode == formMode.VIEW){
                    <button class="btn btn-outline-primary btn-sm" (click)="onModeChange(formMode.EDIT)">
                        <i class="fa fa-edit"></i> Editar
                    </button>
                    <button class="btn btn-outline-secondary btn-sm ms-2" (click)="closeClaim()">
                        <i class="fa fa-times"></i> Cerrar
                    </button>
                    }
                </div>
            </form>

        </div>
    </div>
</div>
}

<!-- Información del Vehículo -->
@if(data().vehicle){
<div class="row mt-3">
    <div class="col-12">
        <div class="panel">
            <div class="panel-header p-3 mb-0 bg-none">
                <b>Información del Vehículo</b>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-3">
                        <label class="text-muted">Placa</label>
                        <p><strong>{{data().vehicle.plate}}</strong></p>
                    </div>
                    <div class="col-md-5">
                        <label class="text-muted">Descripción</label>
                        <p><strong>{{data().vehicle.brand?.name}} {{data().vehicle.model?.name}}
                                {{data().vehicle.year}}</strong></p>
                    </div>
                    <div class="col-md-2">
                        <label class="text-muted">Color</label>
                        <p><strong>{{data().vehicle.color?.name}}</strong></p>
                    </div>
                    <div class="col-md-2">
                        <label class="text-muted">Valor</label>
                        <p><strong>${{data().vehicle.value | number:'1.0-0'}}</strong></p>
                    </div>
                </div>
                @if(data().vehicle.party){
                <div class="row">
                    <div class="col-md-3">
                        <label class="text-muted">Propietario</label>
                        <p><strong>{{data().vehicle.party.names}}</strong></p>
                    </div>
                    <div class="col-md-3">
                        <label class="text-muted">RUT</label>
                        <p><strong>{{data().vehicle.party.rut}}</strong></p>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>
}